export { default } from './NextAnchor';
export * from './NextAnchor';
